import { api } from "@services/baseURL";

export const SaveItemProcesso = async (data) => {
  try {
    const response = await api.post('ProcessoItems', data);
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar item do processo:', error);
    throw error;
  }
};

export const UpdateItemProcesso = async (id, data) => {
  try {
    const response = await api.patch(`ProcessoItems/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar item do processo:', error.response?.data || error.message);
    throw error;
  }
};

export const DeleteItemProcesso = async (id) => {
  try {
    await api.delete(`ProcessoItems/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar item do processo:', error);
    throw error;
  }
};

export const GetAllItensDoProcesso = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('ProcessoItems', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos itens do processo:', error);
    throw error;
  }
};

export const GetByIdItemProcesso = async (id) => {
  try {
    const response = await api.get(`ProcessoItems/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar item do processo:', error);
    throw error;
  }
};

export default {
  SaveItemProcesso,
  UpdateItemProcesso,
  DeleteItemProcesso,
  GetByIdItemProcesso,
  GetAllItensDoProcesso
};